import { useTranslation } from 'react-i18next';
import { useStore } from '../store/useStore';
import { useShallow } from 'zustand/react/shallow';

export function ToastContainer() {
  const { t } = useTranslation();
  const { toasts, removeToast } = useStore(
    useShallow((state) => ({ toasts: state.toasts, removeToast: state.removeToast }))
  );

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-2 pointer-events-none">
      {toasts.map((toast) => {
        const styles =
          toast.type === 'error'
            ? 'bg-red-900/90 border border-red-700'
            : toast.type === 'success'
              ? 'bg-emerald-900/90 border border-emerald-700'
              : toast.type === 'warning'
                ? 'bg-amber-900/90 border border-amber-700'
                : 'bg-zinc-800/90 border border-zinc-600';

        return (
          <div
            key={toast.id}
            className={`pointer-events-auto flex items-start gap-3 px-4 py-3 rounded-xl shadow-xl max-w-sm transition-opacity ${styles}`}
          >
            <span className="text-sm text-zinc-100 flex-1">{toast.message}</span>
            <button
              onClick={() => removeToast(toast.id)}
              className="text-zinc-400 hover:text-zinc-200 transition-colors text-xs leading-none mt-0.5 flex-shrink-0"
              aria-label={t('common.close')}
            >
              ✕
            </button>
          </div>
        );
      })}
    </div>
  );
}
